// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"532":"pastelero","550":"pedidos"}[chunkId] + "." + {"532":"7216ddde","550":"eb2cf82c"}[chunkId] + ".js";
};